import { Button, Field } from 'bloomer'
import clsx from 'clsx'
import React, { useState } from 'react'
import IResult from '../../../../../api/types/result'
import { useEventBus } from '../../../../../pages/checklists/ResultView/EventBus'
import { range } from '../../../../../util'

interface Props {
  min: number
  max: number
  value: string
  resultId: string
  onUpdate: (newValue: string) => Promise<IResult>
  disabled: boolean
}

// number of columns so that all rows are (nearly) equally filled,
// e.g. 6 values with max 5 per row -> 3 columns (3 + 3) instead of 5 + 1
function balancedColumns(count: number, maxPerRow: number): number {
  if (count <= maxPerRow) return Math.max(count, 1)
  const rows = Math.ceil(count / maxPerRow)
  return Math.ceil(count / rows)
}

function QuestionRatingInput({
  min, max, value, onUpdate, resultId, disabled
}: Props) {
  const theValue: number = value ? parseInt(value) : 0
  const [isHighlighted, setIsHighlighted] = useState<boolean>(false)

  useEventBus('result', resultId, () => {
    setIsHighlighted(true)
    setTimeout(() => setIsHighlighted(false), 5000)
  })

  // questions saved without a minimum rendered an empty first button (range starting at null)
  const from = Number.isFinite(min) ? min : 1
  const to = Number.isFinite(max) ? max : 5
  const buttons = range(from, to + 1, 1).map((i: number) => (
    <Button
      key={i}
      className="has-text-weight-bold"
      isColor={theValue === i ? 'link' : null}
      isSize="medium"
      onClick={() => onUpdate(i.toString())}
      disabled={disabled}
    >
      { i }
    </Button>
  ))

  // Grid with a fixed, balanced column count (e.g. 6 values -> 3x2 on mobile, 1 row on desktop).
  // The columns shrink with the available width (minmax(0, 1fr)), so the grid never gets wider
  // than the screen. (Bulma columns stacked every button vertically; auto-fill + max-width
  // made the page wider than the phone viewport.)
  const style = {
    '--rating-cols': balancedColumns(buttons.length, 10),
    '--rating-cols-mobile': balancedColumns(buttons.length, 5)
  } as React.CSSProperties

  return (
    <Field className={clsx('question-rating', isHighlighted && 'is-highlighted')}>
      <div className="rating-buttons" style={style}>
        { buttons }
      </div>
    </Field>
  )
}

export default QuestionRatingInput
